import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth13patchPatchScreenTruthRequirementsIdResponseSchema = jsonObject
export type tcpscreentruth13patchPatchScreenTruthRequirementsIdResponse = z.infer<typeof tcpscreentruth13patchPatchScreenTruthRequirementsIdResponseSchema>
